import React, { useCallback } from "react";
import { useDropzone } from "react-dropzone";

const DragDrop = ({
    onFilesUploaded,
    acceptedFileTypes = {},
    maxFiles = 0,
    dragDropText = "Drag and drop files here",
    buttonText = "Upload from here",
    multiple = true,
}) => {
    const onDrop = useCallback(
        (acceptedFiles) => {
            // Send the uploaded files back to the parent component
            onFilesUploaded(acceptedFiles);
        },
        [onFilesUploaded],
    );

    const { getRootProps, getInputProps, open } = useDropzone({
        onDrop,
        noClick: true,
        accept: acceptedFileTypes,
        maxFiles: maxFiles,
        multiple: multiple,
    });

    return (
        <div className="w-full flex flex-col gap-2 py-2 pb-3">
            <div
                {...getRootProps()}
                className="border-[1.5px] border-[#D0D2D4] rounded-2xl p-3 flex flex-col items-center gap-2 cursor-pointer w-[95%]"
            >
                <input
                    {...getInputProps()}
                    id="file-upload"
                    className="hidden"
                />
                <p className="text-center text-gray-400">{dragDropText}</p>
                <p className="text-center text-gray-400">or</p>
                <button
                    type="button"
                    onClick={open}
                    className="bg-[#FF7378] h-[38px] p-4 flex items-center justify-center rounded-lg text-white"
                >
                    {buttonText}
                </button>
            </div>
        </div>
    );
};

export default DragDrop;

// // import React, { useCallback, useState } from "react";
// // import { useDropzone } from "react-dropzone";
// // import { Trash, TextT, Image } from "@phosphor-icons/react";

// // const DragDrop = ({ name }) => {
// //     const [selectedFiles, setSelectedFiles] = useState([]);

// //     const onDrop = useCallback((acceptedFiles) => {
// //         setSelectedFiles((prevFiles) => [...prevFiles, ...acceptedFiles]);
// //     }, []);

// //     const removeFile = (fileName) => {
// //         setSelectedFiles((prevFiles) =>
// //             prevFiles.filter((file) => file.name !== fileName),
// //         );
// //     };

// //     const { getRootProps, getInputProps, open } = useDropzone({
// //         onDrop,
// //         noClick: true, // Disable built-in click action
// //     });

// //     const TrimName = (name) => {
// //         if (!name.length > 0) return "";
// //         if (name.length > 15) return name.substring(0, 15) + "...";
// //         else return name;
// //     };

// //     return (
// //         <div className="h-[inherit]">
// //             <div className="h-[inherit]">
// //                 <div className="flex h-[inherit]">
// //                     <div className="h-[inherit] w-1/2 flex flex-col gap-2 py-2  border-r-[1.5px]  border-b-[1.5px] pb-7">
// //                         <div>
// //                             <label>{name}</label>
// //                             {name === "Guidlines" && (
// //                                 <div className="flex gap-2 p-1 text-xs border-[1.5px] w-fit rounded-full">
// //                                     <div className="bg-[#FF7378] w-fit flex text-white items-center py-1 px-3 gap-1 rounded-full">
// //                                         <Image
// //                                             weight="fill"
// //                                             className="text-lg"
// //                                         />
// //                                         Image
// //                                     </div>
// //                                     <div className="bg-[#FFF2F2] w-fit flex  items-center py-1 px-3 gap-1 rounded-full">
// //                                         <TextT
// //                                             weight="bold"
// //                                             className="text-lg"
// //                                         />
// //                                         Text
// //                                     </div>
// //                                 </div>
// //                             )}
// //                         </div>
// //                         <div
// //                             {...getRootProps()}
// //                             className="border-[1.5px] border-[#D0D2D4] rounded-2xl p-3 flex flex-col items-center gap-2 cursor-pointer w-[95%]"
// //                         >
// //                             <input
// //                                 {...getInputProps()}
// //                                 id="file-upload"
// //                                 className="hidden"
// //                             />
// //                             <p className="text-center text-gray-400">
// //                                 Drag and drop floor plan images here
// //                             </p>
// //                             <p className="text-center text-gray-400">or</p>
// //                             <button
// //                                 type="button"
// //                                 onClick={open}
// //                                 className="bg-[#FF7378] h-[38px] p-4 flex items-center justify-center rounded-lg text-white"
// //                             >
// //                                 Upload from here
// //                             </button>
// //                         </div>
// //                     </div>

// //                     <div
// //                         className={`w-1/2 flex flex-col gap-1 pl-4 h-full py-2 overflow-scroll ${
// //                             selectedFiles.length > 0
// //                                 ? "bg-[#F2F7FF] border-b-[1.5px]"
// //                                 : ""
// //                         }`}
// //                     >
// //                         {selectedFiles.length > 0 && (
// //                             <>
// //                                 <p>Uploaded Floor Plans</p>

// //                                 <div className="flex gap-3   w-fit overflow-scroll">
// //                                     <div className="w-full flex flex-shrink-0 overflow-scroll gap-2">
// //                                         {selectedFiles.map((file) => (
// //                                             <div
// //                                                 key={file.name}
// //                                                 className="flex flex-col items-center rounded-xl border-[1.5px] w-[158px] h-fit overflow-hidden"
// //                                             >
// //                                                 <img
// //                                                     src={URL.createObjectURL(
// //                                                         file,
// //                                                     )}
// //                                                     alt={file.name}
// //                                                     className="min-w-[158px] max-w-full h-28 object-cover"
// //                                                 />
// //                                                 <div className="w-full flex justify-between px-2 bg-[#EEF0FB] items-center gap-3 py-2 ">
// //                                                     <p className="text-xs">
// //                                                         {TrimName(file.name)}
// //                                                     </p>
// //                                                     <button
// //                                                         onClick={() =>
// //                                                             removeFile(
// //                                                                 file.name,
// //                                                             )
// //                                                         }
// //                                                         className="text-white p-1 rounded-lg border-[1.5px] border-[#F8D9DE] bg-white"
// //                                                     >
// //                                                         <Trash
// //                                                             className="text-[#FF7378] text-lg"
// //                                                             weight="bold"
// //                                                         />
// //                                                     </button>
// //                                                 </div>
// //                                             </div>
// //                                         ))}
// //                                     </div>
// //                                 </div>
// //                             </>
// //                         )}
// //                     </div>
// //                 </div>
// //             </div>
// //         </div>
// //     );
// // };

// // export default DragDrop;

// // import React, { useCallback } from "react";
// // import { useDropzone } from "react-dropzone";
// // import { Trash } from "@phosphor-icons/react";

// // const DragDrop = ({ dropzoneText, files, onAddFiles, onRemoveFile }) => {
// //     const onDrop = useCallback(
// //         (acceptedFiles) => {
// //             const filesWithPreview = acceptedFiles.map((file) => ({
// //                 file,
// //                 preview: URL.createObjectURL(file),
// //             }));

// //             onAddFiles(filesWithPreview);
// //         },
// //         [onAddFiles],
// //     );

// //     const removeFile = (fileName) => {
// //         onRemoveFile(fileName);
// //     };

// //     const { getRootProps, getInputProps, open } = useDropzone({
// //         onDrop,
// //         noClick: true, // Disable built-in click action
// //     });

// //     return (
// //         <div>
// //             <div className="w-full flex flex-col gap-2 py-2 pb-7">
// //                 <div
// //                     {...getRootProps()}
// //                     className="border-[1.5px] border-[#D0D2D4] rounded-2xl p-3 flex flex-col items-center gap-2 cursor-pointer w-[95%]"
// //                 >
// //                     <input
// //                         {...getInputProps()}
// //                         id="file-upload"
// //                         className="hidden"
// //                     />
// //                     <p className="text-center text-gray-400">
// //                         {dropzoneText || "Drag and drop files here"}
// //                     </p>
// //                     <p className="text-center text-gray-400">or</p>
// //                     <button
// //                         type="button"
// //                         onClick={open}
// //                         className="bg-[#FF7378] h-[38px] p-4 flex items-center justify-center rounded-lg text-white"
// //                     >
// //                         Upload from here
// //                     </button>
// //                 </div>
// //                 <div className="grid grid-cols-2 gap-4 mt-4">
// //                     {files &&
// //                         files.map((file, index) => (
// //                             <div key={index} className="relative">
// //                                 <img
// //                                     src={file.preview}
// //                                     alt={file.file.name}
// //                                     className="w-full h-auto rounded-lg"
// //                                 />
// //                                 <button
// //                                     className="absolute top-2 right-2 bg-red-500 text-white rounded-full p-1"
// //                                     onClick={() => removeFile(file.file.name)}
// //                                 >
// //                                     <Trash size={20} />
// //                                 </button>
// //                             </div>
// //                         ))}
// //                 </div>
// //             </div>
// //         </div>
// //     );
// // };

// // export default DragDrop;

// import React, { useCallback, useState } from "react";
// import { useDropzone } from "react-dropzone";

// const DragDrop = ({
//     onFilesChange,
//     maxFiles = 0,
//     // dragDropText = "Drag and drop files here",
//     buttonText = "Upload from here",
//     multiple = true,
// }) => {
//     const onDrop = useCallback(
//         (acceptedFiles) => {
//             // Send the files back to the parent component
//             onFilesChange(acceptedFiles);
//         },
//         [onFilesChange],
//     );

//     const { getRootProps, getInputProps, open } = useDropzone({
//         onDrop,
//         noClick: true,
//         accept: [".jpeg", ".png", ".jpg"],
//         maxFiles: maxFiles,
//         multiple: multiple,
//     });

//     return (
//         <div className="w-full flex flex-col gap-2 py-2 pb-7">
//             <div
//                 {...getRootProps()}
//                 className="border-[1.5px] border-[#D0D2D4] rounded-2xl p-3 flex flex-col items-center gap-2 cursor-pointer w-[95%]"
//             >
//                 <input
//                     {...getInputProps()}
//                     id="file-upload"
//                     className="hidden"
//                 />
//                 <p className="text-center text-gray-400">
//                     Drag and drop files here
//                 </p>
//                 <p className="text-center text-gray-400">or</p>
//                 <button
//                     type="button"
//                     onClick={open}
//                     className="bg-[#FF7378] h-[38px] p-4 flex items-center justify-center rounded-lg text-white"
//                 >
//                     Upload from here
//                 </button>
//             </div>
//         </div>
//     );
// };

// export default DragDrop;
